import { SecurityBriefDocument } from "./SecurityBriefDocument";

export default SecurityBriefDocument;
